import React from 'react';
import PropTypes from 'prop-types';
import {TextField, Grid, Button, Typography} from '@mui/material';
import { withTheme } from '@mui/styles';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';

const errorStyle = {
	container: {
		position: 'absolute',
		bottom: '9px',
		right: '1px',
		left: '1px',
		borderRadius: '2px',
		margin: '2px',
		border: '1px solid rgb(250, 87, 80)',
		padding: '12px',
		background: 'rgba(0,0,0,.2)',
		backdropFilter: 'blur(10px)',
		maxHeight: '60%',
	},
	message: {
		color: 'rgb(250, 87, 80)',
		fontFamily: 'monospace',
		fontSize: '12px',
	}
};

const ErrorsContainer = ({ errors, ...props }) => {
	if (!errors?.length) {
		return null;
	}
	return (
		<div style={ errorStyle.container }>
			{ errors.map(error =>
				<>
					<Typography style={ errorStyle.message }>{ error.message }</Typography>
					{ error.expected &&
						<div key={ error.message }>
							<Typography style={ errorStyle.message }>- Expected: { error.expected }</Typography>
							<Typography style={ errorStyle.message }>- Received: { error.received }</Typography>
						</div>
					}
				</>
			)}
		</div>
	);
};

ErrorsContainer.propTypes = {
	errors: PropTypes.array,
};

class FixRequestRawInput extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			requestInput: '',
		};

		this.onChange = this.onChange.bind(this);
	}

	onChange(event) {
		this.setState({ requestInput: event.target.value });
		if (!event.target.value) {
			this.props.onClear();
		}
	}

	clear() {
		this.setState({ requestInput: '' });
		this.props.onClear();
	}

	send() {
		this.props.onSend(this.state.requestInput);
	}

	render() {
		return (
			<div style={{ display: 'flex', flexFlow: 'column', height: '100%', overflow: 'hidden', padding: 8, background: this.props.theme.palette.background.paper }}>
				<div style={{ overflow: 'none', flex: '1 1 auto' }}>
					<AutoSizer>
						{({ height, width }) => (
							<>
								<TextField
									type="text"
									value={this.state.requestInput}
									label="Message"
									onChange={this.onChange}
									onBlur={this.onChange}
									multiline={true}
									margin="dense"
									variant="outlined"
									error={!!this.props.errors?.length}
									fullWidth
									InputProps={{
										style: { padding: 2, height: height - 16, width: width },
										inputProps: {
											style: { padding: '8px 4px', height: height - 36, width: width - 12, fontFamily: 'monospace', fontSize: '13px' },
										}
									}}
									InputLabelProps={{
										shrink: true,
									}}
								/>
								{ this.props.errors && <ErrorsContainer errors={this.props.errors} /> }
							</>
						)}
					</AutoSizer>
				</div>
				<div style={{ flex: '0 1 auto', position: 'relative' }}>
					<Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
						<Grid item><Button size="small" onClick={() => this.clear()}>Clear</Button></Grid>
						<Grid item><Button size="small" variant="contained" color="primary" onClick={() => this.send()}>Send</Button></Grid>
					</Grid>
				</div>
			</div>
		);
	}
}

FixRequestRawInput.propTypes = {
	onSend: PropTypes.func,
	onClear: PropTypes.func,
	theme: PropTypes.object,
	errors: PropTypes.array,
};


export default withTheme(FixRequestRawInput);
